
// The parts themselves must also be constants

/**
 * @internal
 */
export const ToolbarConstants = {
  attrToMarkInitalized: '2sxc-tagtoolbar',
  attr: {
    full: 'sxc-toolbar',
    hover: 'sxc-toolbar-hover',
    disable: 'data-disable-toolbar',
  },
  classes: {
    oldHover: 'sc-element',
  },
  selectors: {
    ofOldHover: '.sc-element',
  },
  eventNames: {
    onInit: 'toolbar-init',
  },
};
